<template>
  <span>
    <b-row style="margin-top: 40px; width: 98%" class="mx-auto">
      <b-col lg="4">
        <b-card>
          <h6 class="text-center">Track Item</h6>
          <br />

          <b-form @submit="request">
            <div class="form-group mb-3 input-group input-text-wrapper">
              <div class="input-group-prepend">
                <span
                  class="input-group-text"
                  style="background-color: #ffffff; border: none"
                >
                  <font-awesome-icon icon="search" style="color: #ced4da" />
                </span>
              </div>
              <b-form-input
                v-model="trck_no"
                class="box-text-input"
                placeholder="Tracking Number"
                required
                type="text"
              >
              </b-form-input>
            </div>

            <br />

            <button
              class="form-control signUpButtonCard button"
              style="margin-bottom: 4%"
              type="submit"
            >
              Track&nbsp;
              <b-spinner
                v-if="trackSpinner"
                label="Loading..."
                small
              ></b-spinner>
            </button>
          </b-form>
        </b-card>
      </b-col>

      <b-col lg="8">
        <b-card>
          <b-row v-for="item in getTracking" :key="item">
            <Timeline :data="item"></Timeline>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Timeline from "@/views/dashboard/delivery/Timeline";
export default {
  name: "TrackinInternal",
  components: { Timeline },
  data() {
    return {
      trck_no: null,
      trackSpinner: false,
    };
  },
  mounted() {
    let data = {
      client_id: this.getClientId,
    };
    this.fetchOrders(data);
  },
  computed: {
    ...mapGetters(["getClientId", "getTracking", "getTrackingRequestError"]),
    tracking_response() {
      return this.getTracking;
    },
    tracking_error() {
      return this.getTrackingRequestError;
    },
  },
  watch: {
    tracking_response() {
      this.trackSpinner = false;
      this.$bvModal.hide("request_tracking");
      this.$bvModal.show("track");
    },
    tracking_error(error) {
      this.trackSpinner = false;
      this.$swal({
        title: error.status,
        text: error.message,
      });
    },
  },
  methods: {
    ...mapActions(["makeTrackingRequest"]),
    request: function (e) {
      this.trackSpinner = true;
      e.preventDefault();
      let data = {
        tracking_no: this.trck_no,
      };
      this.makeTrackingRequest(data);
    },
  },
};
</script>

<style scoped>
@import "../../commons/tables.css";

.delivery {
  width: 100%;
}

.action {
  margin-top: 30px;
  margin-left: 20px;
}

.button {
  background: #db0000;
  border: none;
  border-radius: 2px;
  color: #fff;
  padding: 8px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}

.button:hover {
  background: #9f0012;
}

.input {
  width: 100%;
  margin-bottom: 10px;
}

.form {
  width: 100%;
  margin: 15px;
}

.results {
  width: 90%;
  margin-top: 10px;
  margin-left: 20px;
}

.key-label {
  color: #222222;
  font-size: 14px;
  font-weight: bold;
}

.label {
  color: #222222;
  font-size: 14px;
}

.signUpButtonCard {
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  margin-top: 4%;
}

.input-text-wrapper {
  border: #ced4da 1px solid;
  padding: 3px;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 8px;
}

.box-text-input {
  border: none;
  font-size: 13px;
  height: 13vm;
  color: #8898aa;
  outline: none;
  box-shadow: none !important;
}

.status {
  font-size: 14px;
  background: #0a7027;
  color: white;
  padding: 4px 8px;
  border-radius: 3px;
  margin-left: 1px;
  font-weight: bold;
  text-align: center;
}
</style>
